import {connect} from 'react-redux';
import * as chapterPartActions from '../../store/actions/chapterPartActions';
import EditChapterTest from '../../components/AdminPanel/EditChapterTest';
import * as VideoActions from '../../store/actions/videoActions';


const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.chapterPart,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    loadBlank: () => {
        dispatch(chapterPartActions.loadBlanks());
    },
    saveTest: (test, token) => {
        dispatch(chapterPartActions.updateChapterTest(test, token));
    },
    getTest: (id, token) => {
        dispatch(chapterPartActions.getChapterTest(id, token));
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditChapterTest);


// WEBPACK FOOTER //
// ./src/containers/AdminPanel/EditChapterTestContainer.js